import { useCallback, useEffect, useState } from "react";
import { MonitorPlay, Loader2, CopyPlus } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { CopyDayDialog } from "@/components/linear/CopyDayDialog";
import { ChannelStatus } from "@/components/linear/ChannelStatus";
import { ScheduleGrid } from "@/components/linear/ScheduleGrid";
import { SlotDialog } from "@/components/linear/SlotDialog";

export default function LinearTv() {
  const [status, setStatus] = useState(null);
  const [slots, setSlots] = useState([]);
  const [library, setLibrary] = useState({ videos: [], playlists: [] });
  const [edit, setEdit] = useState(null);
  const [copyOpen, setCopyOpen] = useState(false);

  const move = async (s, n) => {
    setSlots((list) => list.map((x) => (x.id === s.id ? { ...x, day: n.day, start_min: n.start_min, end_min: n.end_min } : x)));
    try {
      await api.put(`/linear/slots/${s.id}`, { day: n.day, start_min: n.start_min, end_min: n.end_min, content_kind: s.content_kind, content_id: s.content_id, video_kind: s.video_kind });
      toast.success("Slot moved");
    } catch (e) { toast.error(e.response?.data?.detail || "Couldn't move the slot"); }
    loadSlots();
  };

  const loadStatus = useCallback(() => api.get("/linear/status").then((r) => setStatus(r.data)).catch(() => {}), []);
  const loadSlots = useCallback(() => api.get("/linear/slots").then((r) => setSlots(r.data.slots)).catch(() => {}), []);
  useEffect(() => {
    loadStatus(); loadSlots();
    api.get("/linear/library").then((r) => setLibrary(r.data)).catch(() => {});
    const t = setInterval(loadStatus, 5000);
    return () => clearInterval(t);
  }, [loadStatus, loadSlots]);

  return (
    <div data-testid="linear-page" className="p-6 lg:p-10 max-w-[1500px] space-y-6">
      <div>
        <p className="text-xs uppercase tracking-[0.25em] text-amber-400/80 font-semibold flex items-center gap-2"><MonitorPlay className="h-3.5 w-3.5" /> The Way Network</p>
        <h1 className="font-display text-4xl sm:text-5xl font-bold text-white mt-2">Linear TV Scheduler</h1>
        <p className="text-gray-400 mt-2 text-sm">Build the weekly lineup for the 24/7 channel. Click an empty spot on the grid to schedule a video or playlist.</p>
      </div>
      {!status ? <div className="py-10 flex justify-center"><Loader2 className="h-6 w-6 animate-spin text-amber-400" /></div>
        : <ChannelStatus status={status} playlists={library.playlists} onChange={loadStatus} />}
      <div className="flex items-center justify-between gap-3">
        <h2 className="font-display font-semibold text-white">Weekly lineup <span className="text-xs font-normal text-gray-500">Eastern Time</span></h2>
        <button data-testid="linear-copy-day" onClick={() => setCopyOpen(true)} disabled={!slots.length} className="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg border border-gray-700 text-gray-300 hover:text-white hover:border-gray-600 text-sm transition-colors disabled:opacity-40"><CopyPlus className="h-4 w-4" /> Copy day</button>
      </div>
      <ScheduleGrid slots={slots} onAdd={setEdit} onEdit={setEdit} onMove={move} nowSlotId={status?.now_playing?.slot_id} />
      {edit && <SlotDialog slot={edit} library={library} onClose={() => setEdit(null)} onSaved={loadSlots} />}
      {copyOpen && <CopyDayDialog slots={slots} onClose={() => setCopyOpen(false)} onDone={loadSlots} />}
    </div>
  );
}
